require('./bootstrap');
require('startbootstrap-sb-admin-2/js/sb-admin-2');
require('./global/ajax-form');
require('./admin/scripts');
require('./admin/destroy-confirmation');
require('./b2b/confirmation');
require('livewire-sortable');
require('./global/pikaday-config');
